import $ from 'jquery';
import type { Select2 } from 'lib/select2';

function copyCompaniesToCheckinableCompanies() {
  const $checkinableCompaniesSelect = $('.js-event-checkinable-companies-select');
  const $companiesSelect = $('.js-event-companies-select');
  if ($companiesSelect.length === 0) return;

  // val(null) だけだと、 select の下の optionタグが消えず、次にUIから追加したときに選択が増殖してしまった
  $checkinableCompaniesSelect.val(null);
  $checkinableCompaniesSelect.find('option').remove();

  const dataArray: Select2.OptionData[] = $companiesSelect.select2('data');
  const options = dataArray.map((data) => new Option(data.text, data.id, true, true));
  const items = dataArray.map((data) => ({ id: data.id, text: data.text, name: data.text }));

  // see https://select2.org/programmatic-control/add-select-clear-items#preselecting-options-in-an-remotely-sourced-ajax-select2
  $checkinableCompaniesSelect.append(options).trigger('change');
  $checkinableCompaniesSelect.trigger({ type: 'select2:select', params: { data: items } });

  $('.checkin_company_list .item').addClass('active');
  const $selectNum = $('.js-event-checkinable-companies-select').val()?.length || 0;
  $('.checkin_company_list-num').text($selectNum);
}

window.addEventListener('DOMContentLoaded', () => {
  const button = document.querySelector('.js-copy-companies-to-checkinable-companies');
  if (!button) return;

  button.addEventListener('click', (e) => {
    e.preventDefault();
    copyCompaniesToCheckinableCompanies();
  });
});
